export default __webpack_public_path__ + "static/media/tool-icon-horde-high.230320a6.svg";